/**
 * App Dark Theme
 */
import { createMuiTheme } from "@material-ui/core/styles";
import grey from "@material-ui/core/colors/grey";

import AppConfig from "Constants/AppConfig";

const { darkBgColor } = AppConfig.darkThemeColors;

function setAppConfig() {
  let appConfig = localStorage.getItem("APP_CONFIG");
  if (appConfig) {
    appConfig = JSON.parse(appConfig);
    AppConfig.sidebarTenantLogo = appConfig.portalSidebarImage;
    AppConfig.themeColors.primary = appConfig.primaryColor;
    AppConfig.themeColors.primaryDark = appConfig.primaryDark;
    AppConfig.themeColors.secondary = appConfig.secondaryColor;
    AppConfig.themeColors.portalFontColor = appConfig.portalFontColor;
    document
      .querySelector("body")
      .style.setProperty("--primary", AppConfig.themeColors.primary);
    document
      .querySelector("body")
      .style.setProperty("--primaryDark", AppConfig.themeColors.primaryDark);
    document
      .querySelector("body")
      .style.setProperty(
        "--portalFontColor",
        AppConfig.themeColors.portalFontColor
      );
    document
      .querySelector("body")
      .style.setProperty("--secondary", AppConfig.themeColors.secondary);
  }
}
setAppConfig();
const theme = createMuiTheme({
  palette: {
    type: "dark",
    types: {
      dark: {
        background: {
          paper: darkBgColor,
          default: darkBgColor,
          appBar: darkBgColor,
          contentFrame: darkBgColor,
          chip: darkBgColor,
          avatar: darkBgColor,
          tabs: darkBgColor
        }
      }
    },
    primary: {
      light: grey[400],
      main: grey[700],
      dark: grey[900],
      contrastText: "#fff"
    },
    secondary: {
      light: grey[700],
      main: grey[700],
      dark: grey[700],
      contrastText: "#fff"
    },
    background: {
      paper: darkBgColor,
      default: darkBgColor,
      appBar: darkBgColor,
      contentFrame: darkBgColor,
      chip: darkBgColor,
      avatar: darkBgColor,
      tabs: darkBgColor
    }
  },
  status: {
    danger: "orange"
  },
  typography: {
    button: {
      fontWeight: 400,
      textAlign: "capitalize"
    },
    useNextVariants: true
  }
});

export default theme;
